"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ThemeProvider = require("../ThemeProvider");
var _utils = require("../utils");
var _LinkBase = _interopRequireDefault(require("./LinkBase"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * `ChevronLink` is a convenience wrapper around the `Link` component to enable "directional" links.
 * It effectively pre-binds left and right icons, and a directional translation of the icon on hover.
 *
 * ChevronLink is not intended to be deeply themable; variants passed to ChevronLink are forwarded to Link.
 */const ChevronLink = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    direction = 'right',
    children,
    tokens = {},
    variant,
    dataSet,
    ...otherlinkProps
  } = _ref;
  const getChevronTokens = (0, _ThemeProvider.useThemeTokensCallback)('ChevronLink', tokens, variant);
  const applyChevronTokens = linkState => {
    const {
      leftIcon,
      rightIcon,
      iconDisplace,
      height,
      fontSize,
      ...otherTokens
    } = getChevronTokens(linkState);
    const linkTokens = (0, _utils.selectTokens)('Link', otherTokens);
    return {
      ...linkTokens,
      height,
      blockFontSize: tokens.fontSize ?? fontSize,
      icon: direction === 'right' ? rightIcon : leftIcon,
      iconTranslateX: iconDisplace * (direction === 'right' ? 1 : -1) || 0
    };
  };
  const getTokens = (0, _ThemeProvider.useThemeTokensCallback)('Link', applyChevronTokens, variant);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_LinkBase.default, {
    ...otherlinkProps,
    iconPosition: direction,
    tokens: getTokens,
    dataSet: dataSet,
    ref: ref,
    children: children
  });
});
ChevronLink.displayName = 'ChevronLink';
ChevronLink.propTypes = {
  ..._LinkBase.default.propTypes,
  children: _propTypes.default.node,
  variant: _propTypes.default.exact({
    size: _propTypes.default.oneOf(['large', 'small', 'micro']),
    alternative: _propTypes.default.bool,
    inverse: _propTypes.default.bool
  }),
  ..._utils.linkProps.types,
  tokens: (0, _utils.getTokensPropType)('ChevronLink', 'Link'),
  /**
   * Changes direction of chevron icon
   */
  direction: _propTypes.default.oneOf(['left', 'right'])
};
var _default = exports.default = ChevronLink;